<template>
  <div class="record pb-5">
    <div class=" max-w-[600px] mx-auto">
      <img src="../assets/images/back (1).png" class="absolute top-5 left-5 w-[30px]" @click="goHome()" alt="">
      <img src="../assets/images/exchange_banner.png" class="w-full" alt="" @click="goHome()">
      <div class="p-4 max-w-[900px] md:mx-auto">
        <p class="mb-2 text-4xl font-bold text-[#c27719]">兌換紀錄</p>
        <p class="font-bold text-lg px-2 mb-5 text-white">
          歡迎30人以下製造業與服務業企業主與員工參加「程曦_企業AI數位培訓」課程報名活動，只要您完成「課程報名」即獲i點數，並且揪企業好友一起參加完成「課程報名」，再獲得i點數，獲得點數可參加優惠券兌換活動。邀請您一起兌換各項禮券，共享優惠，享受生活中的小確幸！
        </p>
        <!-- <div class="flex">
          <div class="tab" :class="{'tab-check': tabCheck === '1'}"  @click="tabChange('1')">
            <div class="flex  justify-start">
              <img src="../assets/images/icon-point-black.png" class="h-[20px] mr-1" alt="">
              <p>電子票券</p>
            </div>
            <div class="flex items-end justify-center">
              <p class="text-3xl font-black mr-3">{{ rewardType(1) }}</p>
              <p>張</p>
            </div>
          </div>
          <div class="tab" :class="{'tab-check': tabCheck === '2'}"  @click="tabChange('2')">
            <div class="flex  justify-start">
              <img src="../assets/images/gift_icon.png" class="h-[20px] mr-1" alt="">
              <p>體驗與禮品</p>
            </div>
            <div class="flex items-end justify-center">
              <p class="text-3xl font-black mr-3">{{ rewardType(0) + rewardType(2) + rewardType(3) }}</p>
              <p>份</p>
            </div>
          </div>
        </div> -->
        <div class="text-center font-bold my-3" v-if="tabCheck == 2"><span class="text-red-500">!</span>請注意<span class="text-red-500">!</span><br>1.好禮領取期限至10/5，請於9/20-10/5期間內使用。<br>2.集點活動有效時間至9/23 18:00，未兌換的點數將視為無效。</div>
        <div class="mt-3 grid grid-cols-2 gap-2" ref="targetElement">
          <div class="bg-white py-5 px-2 box-item relative" v-for="(item, index) in showList" :key="index">
            <div  v-if="isFinish(item)" class="z-50 bg-[#0c0c0cbf] w-full h-full absolute top-0 left-0 rounded-[10px] flex items-center justify-center">
              <div class="text-center">
                <p class="text-2xl text-red-500 font-bold">已完成兌換</p>
              </div>
            </div>
            <span class="rounded-[12px] bg-[#40a79e] absolute top-1 right-1 text-white p-0.5 text-xs" v-if="JSON.parse(item.rewardsInfo).type == 1 || JSON.parse(item.rewardsInfo).type == 2 || JSON.parse(item.rewardsInfo).type == 3">電子票券</span>
            <div>
              <img :src="`https://csai.uupon.com/img/prod_${item.rewardsId}.jpg`" class="mx-auto w-3/4 rounded-full object-cover aspect-square mb-2" alt="">
              <!-- <img :src="require(`../assets/images/prod_1.jpg`)" class="mx-auto w-3/4 rounded-full object-cover aspect-square mb-2" alt=""> -->
              <div>
                <p class="font-bold">{{ getFirstPart(item) }}</p>
                <p class="mb-2 font-bold">{{ getSecondPart(item) }}</p>
              </div>
            </div>
            <!-- <div v-if="JSON.parse(item.rewardsInfo).type == 1">
              <div class="flex items-center justify-center">
                <img src="../assets/images/point_icon.png" width="30" alt="">
                <p class="font-bold"><span class="mx-1 text-2xl text-[#c27719]">{{ item.points }}</span>點</p>
              </div>
            </div> -->
            <div class="w-full">
              <!-- <button class="flex items-center justify-center rounded-full bg-[#40a79e] py-1 w-3/4 mx-auto text-white cursor-pointer" @click="gotoInfo(item)"><span class="text-red-500 font-bold text-xl shine mr-1">{{checkHasBiko(item)?' ! ':''}}</span>寄送資訊<span class="text-red-500 font-bold text-xl shine ml-1">{{checkHasBiko(item)?'!':''}}</span></button> -->
              <!-- <button class="flex items-center justify-center rounded-full bg-[#40a79e] py-1 w-3/4 mx-auto text-white cursor-pointer" @click="exchange(item)">{{ isFinish(item) ? '兌換完成' : '立即兌換'}}</button> -->
              <button class="flex items-center justify-center rounded-full bg-[#40a79e] py-1 w-3/4 mx-auto text-white cursor-pointer" v-if="JSON.parse(item.rewardsInfo).type == 1 || JSON.parse(item.rewardsInfo).type == 2" @click="boxContent = item, showDetail = true">顯示序號</button>
              <button class="flex items-center justify-center rounded-full bg-[#40a79e] py-1 w-3/4 mx-auto text-white cursor-pointer" v-if="JSON.parse(item.rewardsInfo).type == 3" :class="{'bg-[#696969]': isFinish(item)}" @click="openBox(item)">{{ isFinish(item) ? '兌換完成' : '立即兌換'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div @click="showNoticeModel = true" class="bg-[#40a79e] rounded-l-lg p-2 text-white font-bold z-[99] cursor-pointer max-w-14 fixed right-0 bottom-10">
      <p>活</p>
      <p>動</p>
      <p>注</p>
      <p>意</p>
      <p>事</p>
      <p>項</p>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showDetail">
      <div class="modal-content max-h-[85vh] overflow-y-scroll shadow px-5 py-6 text-[#868686]">
          <p class="mb-3 font-bold text-xl text-black">{{JSON.parse(boxContent.rewardsInfo).rewardsName}}</p>
          <div class="flex items-center mb-3">
            <img :src="`https://csai.uupon.com/img/prod_${boxContent.rewardsId}.jpg`" class="w-1/3 rounded-full object-cover aspect-square mb-2" alt="">
            <p class="w-full text-center text-xl font-bold text-black">{{ JSON.parse(boxContent.rewardsInfo).pincode || 123456789 }}</p>
          </div>
          <div class="text-left mb-2">獎品內容:{{JSON.parse(boxContent.rewardsInfo).description.split('&&')[0]}}</div>
          <p><span class="text-red-500">!</span>注意事項<span class="text-red-500">!</span></p>
          <div v-html="filteredDescription" class="text-left mb-2"></div>
          <button v-if="!comfirmModel" class="rounded-full text-white bg-zinc-400 py-1 shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] w-1/3 cursor-pointer" @click="showDetail = false">返回</button>
          <div v-if="comfirmModel">
            <p class="my-3"><span class="text-red-500 font-bold text-xl shine ml-1">!</span>請交給工作人員確認，勿自行兌換<span class="text-red-500 font-bold text-xl shine ml-1">!</span></p>
            <div class="flex items-center justify-center text-white">
              <button class="rounded-full bg-[#696969]  py-2 w-1/3 cursor-pointer mr-2" @click="showDetail = false, comfirmModel = false">取消兌換</button>
              <button class="rounded-full bg-[#40a79e]  py-2 w-1/3 cursor-pointer" @click="exchange()">確定兌換</button>
            </div>
          </div>
      </div>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showNoticeModel">
      <div class="relative max-w-[900px] h-full flex items-center justify-center">
        <img src="../assets/images/btn_close.png" @click="showNoticeModel = false" class="absolute right-5 top-7 max-w-[50px] cursor-pointer" width="35px" alt="">
        <div class="relative rounded-lg p-5 max-h-[80vh] w-[90%] mx-auto overflow-y-auto bg-white">
          <div class="text-left  text-sm text-[#3c3d3d]">
            <p class="font-bold">凡參加兌換優惠券者，視為同意下列事項及主辦單位活動辦法：</p>
            <br>
            <ul style="list-style: none;" class="leading-6 pl-4">
              <li>1.參加者須加入「程曦_企業AI數位培訓」LINE官方帳號好友並完成「課程報名」獲得i點數，始得參加「程曦_企業AI數位培訓 」優惠券兌換活動（以下簡稱本活動）。</li>
              <li>2.參加者於參加本活動同時，即同意接受本活動各式活動辦法規範，如有違反，程曦資訊整合股份有限公司（以下簡稱本公司）得取消參加資格，並得就因此所產生之損害，向該參加者請求損害賠償。</li>
              <li>3. 本公司保留隨時修正、暫停、終止或解釋本活動之最終權利（包括但不限於更換活動、提前終止或延長活動時間之最終決定權等事項），並以本活動公告為準。</li>
              <li>4. 本活動之活動時間、方式、活動獎項與數量，依本活動相關分享資訊為準，優惠券好禮數量有限，換完為止。</li>
              <li>5. 本活動為電子票券，圖片僅供參考。票券使用方式依店家規範為準。本公司保有修改或變更活動方式及更換活動獎品權利。本活動獎品如遇有缺貨或不可抗力之因素無法提供時，本公司有權以其他等值商品替代。</li>
              <li>6. 參加者不得以任何非法、欺騙、不實、不公平、不適當、或其他技術性作弊方式取得參加或中獎資格，本公司有權檢視各活動參加者之活動參與行為、兌換情形、集點取得來源是否涉嫌異常情形，例如：人為操作、非屬正常消費集點、蓄意偽造、短時間異常多筆參與行為、透過任何電腦程式參與活動、詐欺或以任何其他不正當的方式，進行不實或虛偽之活動參與行為。活動參加者因上述情形所獲得之活動資格及獎額，或有破壞活動之行為，本公司有權取消其活動資格或兌換資格，若致本公司蒙受任何損害，本公司有權向參加者請求損害賠償。如活動進行中發生參與者有違反常理、或涉嫌不法、或以惡意或不正當之方式影響活動等異常狀況者，本公司有權變更本活動規則。</li>
              <li>7. 本活動如有任何因電腦、網路、電話、技術或其他任何不可歸責於本公司之事由，而使系統服務停止、中斷、誤送活動訊息、兌換通知或使參加者所寄出或登錄之資料有遲延、遺失、錯誤、無法辨識或毀損之情況或有其他任何影響參與者權益之情形，本公司不負任何法律責任，參加者亦不得因此異議。</li>
              <li>8. 本公司保有一切修改、變更、暫停及取消本活動的權利而不作事前通知，亦有對本活動之所有事宜作出解釋或裁決及變更活動獎項及辦法之權利，任何變更內容及其他詳細注意事項公佈於本活動網站，並不另行通知。</li>
              <li>9. 凡參加本活動者，即視為已充分瞭解本注意事項中各項條款，且願意完全遵守及同意本活動之各項規定。</li>
              <li>10. 參加者於參加本活動之同時，即視為同意接受本活動之活動方式、活動辦法、注意事項及「程曦_企業AI數位培訓」系列活動之個人資料報名同意書。如有違反前述任一內容之情事，本活動將取消其活動資格。</li>
              <li>11. 本活動未盡事宜，係依中華民國相關法令補充之，如因本活動涉訟，係依台灣台北地方法院為第一審管轄法院。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="msgModel">
      <div class="modal-content shadow p-5 text-[#868686]">
        <p class="my-3">{{ responseMsg }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#40a79e]  py-2 w-1/3 cursor-pointer" @click="msgModel = false">確認</button>
        </div>
      </div>
    </div>
    <!-- <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="comfirmModel">
      <div class="modal-content shadow p-5 text-[#868686]">
        <p class="my-3"><span class="text-red-500 font-bold text-xl shine ml-1">!</span>請交給工作人員確認，勿自行兌換<span class="text-red-500 font-bold text-xl shine ml-1">!</span></p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#696969]  py-2 w-1/3 cursor-pointer mr-2" @click="comfirmModel = false">取消兌換</button>
          <button class="rounded-full bg-[#40a79e]  py-2 w-1/3 cursor-pointer" @click="exchange()">確定兌換</button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CryptoJS from 'crypto-js'
import axios from 'axios'

export default {
  name: 'AboutView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      comfirmModel: false,
      msgModel: false,
      rewardList: [],
      tabCheck: '1',
      showList: [],
      showDetail: false,
      boxContent: {},
      inf: '',
      windowHeight: window.innerHeight,
      showNoticeModel: false,
      key: '5334023153340231',
      profile: {},
      encryptedBase64: '',
      decryptedData: null
    }
  },
  created () {
    this.profile.userId = localStorage.getItem('userId') || ''
    this.profile.displayName = localStorage.getItem('displayName') || ''
    if (this.$route.query.recordType === '2') {
      this.tabCheck = '2'
    } else {
      this.tabCheck = '1'
    }
    console.log('this.inf', this.inf)
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.getInf()
  },
  computed: {
    filteredDescription () {
      return this.extractContent(JSON.parse(this.boxContent.rewardsInfo).description)
    }
  },
  methods: {
    extractContent (description) {
      if (!description) return '' // 防止空值錯誤
      const parts = description.split('&&')
      return parts.length > 1 ? parts[1] : parts[0] // 如果有 `&&`，則取後面的內容，否則保留原內容
    },
    decryptData (data) {
      try {
        const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
        const encryptedWordArray = CryptoJS.enc.Base64.parse(data)
        // 使用 AES-128-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encryptedWordArray },
          keyWordArray,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        )
        this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      } catch (error) {
        this.decryptedData = null
      }
    },
    // 加密
    encryptData (data) {
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.encryptedBase64 = encryptedBase64
    },
    getFirstPart (item) {
      if (!JSON.parse(item.rewardsInfo).rewardsName) return ''
      return JSON.parse(item.rewardsInfo).rewardsName.split('-')[0]
    },
    getSecondPart (item) {
      if (!JSON.parse(item.rewardsInfo).rewardsName) return ''
      return JSON.parse(item.rewardsInfo).rewardsName.split('-')[1] || ''
    },
    goHome () {
      this.$router.replace({ name: 'exchange' })
    },
    handleResize () {
      this.windowHeight = window.innerHeight
    },
    gotoInfo (item) {
      console.log('item', item)
      this.$router.push({ name: 'success', query: { biko: JSON.stringify(item.biko), exchangeName: JSON.parse(item.rewardsInfo).rewardsName, id: item.id, type: JSON.parse(item.rewardsInfo).type, openId: item.openId, actId: item.id, source: 'record' } })
      window.sessionStorage.setItem('history', '0')
    },
    openBox (item) {
      if (JSON.parse(item.biko) === 'finish') return
      this.boxContent = item
      console.log('this.boxContent', this.boxContent)
      this.comfirmModel = true
      this.showDetail = true
    },
    rewardType (num) {
      // return this.rewardList.length
      return this.rewardList.filter(item => JSON.parse(item.rewardsInfo).type === num).length
    },
    tabChange (num) {
      this.showList = this.rewardList
      // console.log('num', num, this.rewardList)
      // this.tabCheck = num
      // if (this.tabCheck === '1') {
      //   this.showList = this.rewardList.filter(v => JSON.parse(v.rewardsInfo).type === 1)
      //   console.log('this.rewardList', this.rewardList, this.showList)
      // } else {
      //   console.log('208', this.showList)
      //   console.log('this.showList', this.showList)
      //   this.showList = this.rewardList.filter(v => JSON.parse(v.rewardsInfo).type === 0 || JSON.parse(v.rewardsInfo).type === 2 || JSON.parse(v.rewardsInfo).type === 3)
      //   console.log('this.rewardList', this.rewardList, this.showList)
      // }
    },
    exchange () {
      const recipientInfo = {
        openId: this.openId,
        actId: this.boxContent.id,
        biko: 'finish'
      }
      const jsonString = JSON.stringify(recipientInfo)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const exchangeInfo = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.decryptData(exchangeInfo)
      console.log('263', this.decryptedData)
      axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/EditBiko?inf=${exchangeInfo}`
      }).then((response) => {
        this.responseMsg = response.data.message
        this.comfirmModel = false
        this.showDetail = false
        this.msgModel = true
        this.getList()
      })
    },
    async getInf () {
      console.log('218')
      await axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/LineInfo?lineid=${this.profile.userId}`
      }).then((response) => {
        this.inf = response.data
        this.decryptData(this.inf)
        if (this.decryptedData) {
          console.log(this.decryptedData)
          if (this.decryptedData.code === '100' && this.decryptedData.openId !== '') {
            this.openId = this.decryptedData.openId
          } else {
            this.$router.replace({ name: 'bind', query: { source: 'exchange' } })
          }
          this.getList()
        } else {
          console.log('224', this.decryptedData)
        }
      })
    },
    async getList () {
      // 有帶inf時取得會員投票的紀錄
      const newArray = { openId: this.openId, act: 'exchange' }
      this.encryptData(newArray)
      this.inf = this.encryptedBase64
      console.log(this.inf)
      await axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/RewardsList?inf=${this.inf}&my=1`
      }).then((response) => {
        console.log('response', response)
        this.rewardList = response.data
        if (this.$route.query.type === '2') {
          this.tabChange('2')
        } else {
          if (this.$route.query.recordType === '2') {
            this.tabChange('2')
          } else {
            this.tabChange('1')
          }
        }
      })
    },
    checkHasBiko (item) {
      if (item.biko !== '1') {
        if (item.biko === '2' || item.biko === '3') {
          return true
        } else {
          if (JSON.parse(item.biko).name && JSON.parse(item.biko).phone && JSON.parse(item.biko).mail && JSON.parse(item.biko).address) {
            console.log('162', item)
            return false
          } else {
            console.log('165', item)
            return true
          }
        }
      } else {
        return false
      }
    },
    isFinish (item) {
      if (JSON.parse(item.biko) === 'finish') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.record{
  background: #06133d;
  min-height: 100vh;
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .tab{
    background: #9fd3cf;
    border-radius: 12px;
    width: 50%;
    padding: 12px;
  }
  .tab-check{
    background: #40a79e;
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .shine {
    animation: blink 0.6s infinite;
  }
  .box-item{
    border-radius: 12px;
    border: dotted 2px #40a79e;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-height: 75%;
      overflow-y: auto;
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
    }
    .notice{
      border: 2px solid #40a79e;
    }
  }
}
</style>
